import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  headerContainer: (props: any) => ({
    position: props.matches ? "relative" : "sticky",
    top: props.matches ? "unset" : 0,
    left: props.matches ? "unset" : 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: props.matches ? "3rem" : "3rem",
    width: "100%",
    padding: props.matches ? "0 2rem" : "0 1rem",
    columnGap: props.matches ? "unset" : "0.5rem",
    backgroundColor: theme.whiteColor,
    zIndex: 99,
    borderBottom: props.matches
      ? "none"
      : `2px solid ${theme.darkerWhiteSmokeColor}`,

    "& > div > a, & > div > div > a": {
      color: theme.darkSlateGrayColor,
      textDecoration: "none",
      textTransform: "uppercase",
    },
  }),
  logoContainer: (props: any) => ({
    top: "1.5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99,

    "& img": {
      display: "flex",
      height: "2rem",
    },
  }),
  leftSideContainer: (props: any) => ({
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: props.matches ? "440px" : "100%",
    fontSize: props.matches ? "0.8rem" : "0.7rem",
    zIndex: 99,
  }),
  rightSideContainer: (props: any) => ({
    display: "flex",
    justifyContent: props.matches ? "space-between" : "flex-end",
    alignItems: "center",
    columnGap: "5rem",
    width: props.matches ? "fit-content" : "100%",
    fontSize: props.matches ? "0.8rem" : "0.7rem",
    zIndex: 99,
  }),
  partnerContainer: { minWidth: "max-content" },
  menuContainer: (props: any) => ({
    display: "flex",
    columnGap: props.matches ? "2rem" : "1rem",
    "& a": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  }),
}));

export default useStyles;
